import { ArgumentError } from '../utils/errors';

import { BaseAPIModel } from '@weezevent/weezjs-core';

/**
 * Category.
 *
 * @param {Object} params - Object parameter
 * @param {string} params.name - Name of the category
 * @param {string} params.uuid - Unique identifier
 * @constructor
 */
export default class Category extends BaseAPIModel {
    fields() {
        return {
            uuid: { readOnly: true, primaryKey: true },
            name: {},
            translations: { readOnly: true }
        };
    }

    static listUrl({ organizationId, chartId }) {
        if (!organizationId || !chartId) {
            throw new ArgumentError(`[Model][Category][getAll] organizationId and chartId are mandatory`);
        }

        return `/ticket/organizations/${organizationId}/charts/${chartId}/categories`;
    }
}
